<template>
  <div v-if="category">
    <div
      v-for="(discipline, index) in filteredDisciplines"
      :key="discipline.id"
      class="discipline-section"
      :style="index < filteredDisciplines.length - 1 ? 'page-break-after: always;' : ''"
    >
      <h3>{{ category.name }}</h3>
      <h4>{{ discipline.name }} ({{ getDisciplineData(discipline).length }})</h4>
      <table>
        <thead>
          <tr>
            <th>{{ $tc("general.n0") }}</th>
            <th v-if="!isTeam">{{ $tc("form.image") }}</th>
            <th>{{ $tc("form.name") }}</th>
            <th v-if="!isTeam">{{ $tc("form.belt") }}</th>
            <th v-if="!isTeam">{{ $tc("form.date_of_birth") }}</th>
            <th>{{ $tc("club.short_name") }}</th>
            <th>{{ $tc("general.placement") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(registration, index) in getDisciplineData(discipline)" :key="registration.id">
            <td>{{ index + 1 }}.</td>
            <td v-if="!isTeam" style="width: 80px">
              <div class="image">
                <img
                  :src="$file('avatars', registration.competitor.avatar)"
                  style="width: 75px; height: 75px; object-fit: cover"
                  class="image"
                />
              </div>
            </td>
            <td>
              {{ getCompetitorNames(registration, true) }}
            </td>
            <td v-if="!isTeam">{{ registration.competitor.belt | belt }}</td>
            <td v-if="!isTeam">{{ registration.competitor.born | date }}</td>
            <td>
              <span v-if="registration.club && registration.club.logo" class="club-logo-cell">
                <img
                  :src="$file('avatars', registration.club.logo)"
                  class="club-logo"
                  alt=""
                />
              </span>
              {{ registration.club.shortName }}, {{ registration.club.city }}
            </td>
            <td class="placement-cell">
              <span class="placement-box" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getCompetitors, getCompetitorNames } from './tournament-discipline'

export default {
  props: {
    category: {
      type: Object,
      required: true
    },

    disciplines: {
      type: Array,
      required: true
    },

    isMale: {
      type: Boolean,
      default: null
    },

    competitors: {
      type: Array,
      required: true
    },

    isTeam: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    filteredDisciplines () {
      return this.disciplines.filter(d => this.showDisciplineForGender(d))
    }
  },

  methods: {
    getDisciplineData (discipline) {
      if (!this.showDisciplineForGender(discipline)) {
        return []
      }

      const MF = this.isMale ? 'M' : 'F'
      const filter = this.isMale !== null && !this.isTeam ? MF : null

      let competitors = this.competitors
      if (this.isTeam && this.isMale !== null) {
        let filterType = 'WOMEN'
        if (this.isMale) filterType = 'MEN'
        competitors = competitors.filter(c => c.type === filterType)
      }

      const data = getCompetitors(
        this.category.id,
        discipline.id,
        competitors,
        filter
      ) || []

      if (!this.isTeam && this.isMale !== null) {
        return data.filter((c) => this.isMale === c.competitor?.isMale)
      }

      if (this.isTeam) {
        return data.filter(
          (d) =>
            d.competitor ||
            d.competitorTwo ||
            d.competitorThree ||
            d.competitorFour
        )
      }

      return data
    },

    showDisciplineForGender (discipline) {
      if (this.isMale === null) {
        return true
      }
      if (!discipline.forSex) {
        return true
      }
      return discipline.forSex === (this.isMale ? '1' : '2')
    },

    getCompetitorNames
  }
}
</script>

<style lang="scss" scoped>
.discipline-section {
  page-break-after: always;
  page-break-inside: avoid;
  margin-bottom: 40px;
}

.discipline-section:last-child {
  page-break-after: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  page-break-inside: auto;
}

table thead {
  display: table-header-group;
}

table tbody {
  display: table-row-group;
}

table tr {
  page-break-inside: avoid;
  page-break-after: auto;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f2f2f2;
  font-weight: bold;
  white-space: nowrap;
}

.image {
  width: 75px;
  height: 75px;
  object-fit: cover;
}

.club-logo-cell {
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
}

.club-logo {
  width: 32px;
  height: 32px;
  object-fit: contain;
  vertical-align: middle;
}

.placement-cell {
  width: 44px;
  text-align: center;
  vertical-align: middle;
}

.placement-box {
  display: inline-block;
  width: 28px;
  height: 28px;
  border: 1px solid #333;
  background: #fff;
}

@media print {
  .discipline-section {
    page-break-after: always !important;
    page-break-inside: avoid !important;
  }

  .discipline-section:last-child {
    page-break-after: auto !important;
  }
}
</style>
